<template>
  <div class="ui-praise-wrapper" @click.stop="handlePraise">
    <slot />
  </div>
</template>

<script>
import { worksPraise } from "@/server/interfaces"
import { mapGetters, mapMutations, mapActions } from "vuex"
import getDevicedId from "@/utils/getDeviceId"
import { buryingPoint_praise } from "@/server/buryingPoint"

export default {
  name: "NfPraise",
  props: {
    worksId: {
      type: [String, Number],
      default: ""
    },
    hasPraised: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions({
      handleVerify: "slideVerify/handleVerify"
    }),
    ...mapMutations({
      showOpenApp: "showOpenApp",
      setUserInfo: "userInfo/setUserInfo",
      showToast: "toast/showToast",
      showMessagePopup: "messagePopup/showMessagePopup",
      showLoginByPhonePopup: "loginByPhonePopup/showPopup",
      closeLoginByPhonePopup: "loginByPhonePopup/closePopup"
    }),
    async nvcPraise(nvcData, resfresPraise = true) {
      const params = {
        params: {
          activityId: this.activityId,
          deviceId: getDevicedId(),
          source: this.systemInfo.isNfPlus ? "APP" : "WECHAT",
          user_uuid: this.userUuid,
          worksId: this.worksId,
          nvcVal: nvcData
        },
        showLoading: false
      }
      this.$emit("click")
      buryingPoint_praise({ optionId: this.worksId })
      try {
        this.loading = true
        resfresPraise && this.$emit("resfresPraise")
        const praiseResult = await worksPraise(params)
        this.loading = false
        const { code } = praiseResult
        const isNeedLoginByPhone = code === 30001
        if (isNeedLoginByPhone) {
          this.handleLoginByPhone()
          return
        }
        if (this.aliNvcValStatus === "ON") {
          const prasieCb = () => {
            this.$emit("backPraise")
            this.loading = false
          }
          const sliceSuccessCallback = nvcData => {
            this.nvcPraise(nvcData, false)
          }
          window._nvcCallback = [sliceSuccessCallback]
          await this.handleVerify({ praiseResult, prasieCb })
        }
      } catch (err) {
        window.console.error(err)
        // this.showToast("点赞失败，请稍后再试")
        this.loading = false
      }
    },
    async handlePraise() {
      if (this.voteErrorMsg.status === "error") {
        this.showMessagePopup(this.voteErrorMsg.msg)
        return
      }
      if (this.hasPraised || this.loading) return
      const { isNfPlus } = this.systemInfo
      let hasUserUuid = !!this.userUuid
      if (isNfPlus) {
        if (!hasUserUuid) {
          let userInfo = await window.nfplusJsbridge.getUserInfo()
          hasUserUuid = userInfo && !!userInfo.userUuid
          if (!hasUserUuid) {
            userInfo = await window.nfplusJsbridge.nativeLogin()
            hasUserUuid = userInfo && !!userInfo.userUuid
          }
          if (userInfo) {
            this.setUserInfo(userInfo)
            this.$emit("refreshLogin")
          }
        }
        if (!hasUserUuid) return
      } else if (!hasUserUuid) {
        this.showOpenApp("请打开南方+为作品点赞")
        return
      }
      this.nvcPraise()
    },
    async handleLoginByPhone() {
      const closeCallbackMap = new Map()
      const { isNfPlus } = this.systemInfo
      let hasUserUuid = false
      const login = async () => {
        await window.nfplusJsbridge.quitLogin()
        closeCallbackMap.set("reload", () => {
          window.location.reload()
        })
        this.setUserInfo({ userUuid: "" })
        hasUserUuid = false
        let userInfo = {}
        if (!hasUserUuid) {
          userInfo = await window.nfplusJsbridge.nativeLogin()
          hasUserUuid = userInfo && !!userInfo.userUuid
        }
        if (userInfo) {
          this.setUserInfo(userInfo)
          this.closeLoginByPhonePopup()
        }
      }
      const confirmCallback = () => {
        login()
      }
      const beforeCloseCallback = () => {
        this.$emit("backPraise")
        closeCallbackMap.forEach(cb => {
          cb()
        })
      }
      if (isNfPlus) {
        this.showLoginByPhonePopup({
          confirmCallback,
          beforeShowPopupCallback: null,
          beforeCloseCallback
        })
      } else {
        // this.showOpenApp({
        //   tips: "请打开南方+投票",
        //   closeCallback: () => {
        //     this.$emit("backPraise")
        //   }
        // })
        this.$emit("backPraise")
      }
    }
  },
  computed: {
    ...mapGetters({
      systemInfo: "systemInfo",
      userUuid: "userInfo/userUuid",
      activityId: "activityInfo/activityId",
      aliNvcValStatus: "activityInfo/aliNvcValStatus",
      praiseStatus: "activityInfo/praiseStatus",
      voteErrorMsg: "activityInfo/voteErrorMsg"
    })
  }
}
</script>

<style lang="scss" scoped>
.ui-praise-wrapper {
  display: inline-block;
}
</style>
